import React, { useEffect, useContext, useState } from "react";
import { styles as oldStyles } from "../patients/dashboardstyle";
import api, { API_URL, showAlert, AuthContext, toNaira } from "../util/api";
import { Link, useNavigate } from "react-router-dom";
import InfoContainer from "../components/InfoContainer";
import DoctorTable from "./doctortable";
import PremiumLoader from "../loading";
import NoData from "../components/nodata";

export default function DoctorDashDetails() {
    const { User, token, Doctor } = useContext(AuthContext);
    const router = useNavigate();
    const [balance, setBalance] = useState(0);
    const [ongoing, setOngoing] = useState(0);
    const [completed, setCompleted] = useState(0);
    const [appointments, setAppointments] = useState([]);
    const [doctorAppoint, setDoctorAppoint] = useState(0);
    const [loading, setLoading] = useState(true);

    const [hovered, setHovered] = useState(null);

    const getData = async () => {
        try {
            const response = await api.get(`${API_URL}/doctor-info`);
            if (response.data.status === 'success') {
                const info = response.data;
                setAppointments(info.appointments.data);
                setOngoing(info.ongoing_appointment);
                setCompleted(info.completed_appointment);
                setBalance(info.wallet.balance);
                setDoctorAppoint(info.doctor_appointment);
            } else {
                showAlert('error', 'Error!', response.data.message);
            }
        } catch (err) {
            showAlert('error', 'Error!', 'Failed to fetch data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!User || !token) router("/login");
        if (!Doctor) router("/");
        getData();
    }, []);

    // NEW STYLES
    const styles = {
        container: {
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "25px",
            maxWidth: "1200px",
            margin: "0 auto",
        },
        card: {
            background: "linear-gradient(145deg, #f5f7fa, #e6edf5)",
            borderRadius: "15px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
            padding: "20px",
            transition: "all 0.3s ease",
        },
        cardHover: {
            transform: "translateY(-5px)",
            boxShadow: "0 15px 25px rgba(0,0,0,0.15)",
        },
        header: {
            fontSize: "1.8rem",
            fontWeight: "600",
            marginBottom: "15px",
            color: "#0d3b66",
        },
        grid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "20px",
        },
        statBox: {
            background: "#fff",
            borderRadius: "12px",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #e0e4e8",
        },
        statBoxHover: {
            transform: "scale(1.05)",
            background: "linear-gradient(120deg, #ffecd2, #fcb69f)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
        },
        statLabel: {
            fontSize: "0.95rem",
            fontWeight: "500",
            color: "#555",
            marginBottom: "8px",
        },
        statValue: {
            fontSize: "1.6rem",
            fontWeight: "700",
            color: "#0d3b66",
        },
        tableCard: {
            marginTop: "15px",
            padding: "15px",
        },
        fadeIn: {
            animation: "fadeIn 0.8s ease-out",
        },
    };

    return (
        <>
            {Doctor.status === 'pending' && (
                <InfoContainer theme="red">
                    Your account is undergoing verification.
                    Please wait for approval to access all features.
                </InfoContainer>
            )}

            <div style={styles.container}>
                {/* TOP STATS */}
                <div
                    style={{ ...styles.card, ...styles.fadeIn }}
                    onMouseEnter={() => setHovered("top")}
                    onMouseLeave={() => setHovered(null)}
                >
                    <div style={styles.header}>Doctor Dashboard</div>
                    <div style={styles.grid}>
                        {[
                            { label: "Wallet Balance", value: toNaira(balance), link: "/transactions" },
                            { label: "Ongoing Appointments", value: ongoing, link: "/doctor-ongoing-appointments" },
                            { label: "Completed Appointments", value: completed, link: "/doctor-completed-appointments" },
                            { label: "Doctor Appointments", value: doctorAppoint, link: "/doctor-doctor-appointments" },
                        ].map((item, index) => (
                            <Link key={index} to={item.link} style={{ textDecoration: "none" }}>
                                <div
                                    style={{
                                        ...styles.statBox,
                                        ...(hovered === index && styles.statBoxHover),
                                    }}
                                    onMouseEnter={() => setHovered(index)}
                                    onMouseLeave={() => setHovered(null)}
                                >
                                    <div style={styles.statLabel}>{item.label}</div>
                                    <div style={styles.statValue}>{item.value}</div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* APPOINTMENTS TABLE */}
                <div
                    style={{
                        ...styles.card,
                        ...(hovered === "table" && styles.cardHover),
                        ...styles.fadeIn,
                    }}
                    onMouseEnter={() => setHovered("table")}
                    onMouseLeave={() => setHovered(null)}
                >
                    <div style={styles.header}>Recent Appointments</div>
                    <div style={styles.tableCard}>
                        {loading ? (
                            <PremiumLoader />
                        ) : appointments.length > 0 ? (
                            <DoctorTable appointments={appointments} />
                        ) : (
                            <NoData />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
